export const importDatabase = () => import(
  '../../_database/databaseApis.js'
)
